import { combineReducers } from 'redux'
import { attemptSlice, optionSlice, surveySlice } from './slices'

export * from './sagas'
export * from './selectors'
export * from './slices'

export const survey = combineReducers({
	[attemptSlice.name]: attemptSlice.reducer,
	[optionSlice.name]: optionSlice.reducer,
	[surveySlice.name]: surveySlice.reducer,
})
